import angular from 'angular';
import moment from 'moment';
import { ApuracoesPontoService } from '../apuracoesponto.service';
import { LoadParams } from '../../../../../shared/models/loadparams.model';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../../../utils/nsj-table';
import { IApuracaoPontoGetResponse } from '../../models/apuracaoponto.model';
import {
    ISaldoInicialImportacaoArquivo,
    ISaldoInicialImportacaoArquivoResponse,
    ISaldoInicialImportacaoJsonItemRequest,
    ISaldoInicialRow,
    ISaldoInicialTrabalhadorApiResponse,
} from './models/saldo-inicial.model';
import { SaldoInicialImportarModalService } from './modals/importar/saldo-inicial-importar.modal.service';

export class SaldoInicialController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        'ApuracoesPontoService',
        'NewToaster',
        'SaldoInicialImportarModalService'
    ];

    public busy = false;
    public filters: { busca: string | null } = {
        busca: null,
    };
    public entities: ISaldoInicialRow[] = [];
    public allEntities: ISaldoInicialRow[] = [];
    public loadParams = new LoadParams();
    public apuracao: IApuracaoPontoGetResponse | null = null;
    public apuracaoResumo = '';
    public hasBlockedEntities = false;
    public editingRowId: string | null = null;
    public fields = applyNsjTableInlineMobileLabels([
        {
            value: 'codigo',
            label: 'Matrícula',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'nome',
            label: 'Nome',
            type: 'string',
            style: 'title',
            copy: '',
        },
        {
            value: 'cpf',
            label: 'CPF',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnHtml: () => `<span>{{tableRowEntity.cpf | mask: "999.999.999-99"}}</span>`,
        },
        {
            value: 'saldo',
            label: 'Saldo (HH:MM)',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                formatMinutesToHourString: (minutes: number) => this.formatMinutesToHourString(minutes),
                getSaldoClass: (minutes: number) => this.getSaldoClass(minutes),
            },
            customCollumnHtml: () => `
                <span
                    ng-if="!tableRowEntity.$$editing"
                    ng-class="customCollumnScope.getSaldoClass(tableRowEntity.saldo)"
                    ng-bind="customCollumnScope.formatMinutesToHourString(tableRowEntity.saldo)"
                ></span>
                <div ng-if="tableRowEntity.$$editing">
                    <div style="width: 100%; max-width: 110px;">
                        <input
                            type="text"
                            class="form-control"
                            name="saldoInput"
                            placeholder="00:00"
                            ng-model="tableRowEntity.$$saldoEdicao"
                            time-mask
                            time-mask-model="minutes"
                            time-mask-negative="true"
                            ng-model-options="{ allowInvalid: true }"
                        />
                    </div>
                </div>
            `,
        },
        {
            value: 'id',
            label: 'Ações',
            type: 'div',
            style: 'title',
            copy: '',
            customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
            customCollumnScope: {
                editarSaldo: (entity: ISaldoInicialRow) => this.editarSaldo(entity),
                salvarSaldo: (entity: ISaldoInicialRow) => this.salvarEdicaoSaldo(entity),
                cancelarEdicao: (entity: ISaldoInicialRow) => this.cancelarEdicao(entity),
            },
            customCollumnHtml: () => `
                <div class="display-flex justify-content-center justify-content-end-md gap-5">
                    <button
                        type="button"
                        class="btn btn-link btn-sm"
                        ng-if="!tableRowEntity.$$editing"
                        ng-click="customCollumnScope.editarSaldo(tableRowEntity)"
                        title="{{tableRowEntity.bloqueado ? 'Saldo bloqueado para alteração' : 'Editar saldo'}}"
                    >
                        <i class="fas" ng-class="tableRowEntity.bloqueado ? 'fa-lock text-muted' : 'fa-pencil-alt'"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-link btn-sm"
                        ng-if="tableRowEntity.$$editing"
                        ng-click="customCollumnScope.salvarSaldo(tableRowEntity)"
                        title="Salvar saldo"
                    >
                        <i class="fas fa-save text-success"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-link btn-sm"
                        ng-if="tableRowEntity.$$editing"
                        ng-click="customCollumnScope.cancelarEdicao(tableRowEntity)"
                        title="Cancelar edição"
                    >
                        <i class="fas fa-times text-danger"></i>
                    </button>
                </div>
            `,
        }
    ]);

    constructor (
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
			temPermissao: (arg: string) => boolean,
			session: any,
            nsjGlobals: any
		},
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public ApuracoesPontoService: ApuracoesPontoService,
        public NewToaster: { pop: Function },
        public SaldoInicialImportarModalService: SaldoInicialImportarModalService
    ) {
        this.loadApuracaoHeader();
        this.loadEntities(true);
    }

    loadEntities(reload: boolean = false) {
        if (reload) {
            this.cancelarEdicaoAtual();
        }

        if (reload || !this.allEntities.length) {
            this.busy = true;
            return this.ApuracoesPontoService.listarTrabalhadoresSaldoInicial(this.$stateParams['apuracao'])
                .then((data) => {
                    this.allEntities = data.map((entity) => this.mapEntityFromApi(entity));
                    this.syncBlockedEntitiesState();
                    this.applyFilters();
                })
                .catch((error) => {
                    this.allEntities = [];
                    this.entities = [];
                    this.hasBlockedEntities = false;
                    this.showErrorToast(
                        'Ocorreu um erro ao carregar os saldos iniciais.',
                        this.getErrorMessage(error)
                    );
                })
                .finally(() => {
                    this.busy = false;
                });
        }

        this.applyFilters();
    }

    onBuscaChange() {
        this.applyFilters();
    }

    editarSaldo(entity: ISaldoInicialRow) {
        if (entity.bloqueado) {
            this.showSaldoBloqueadoToast();
            return;
        }

        if (this.editingRowId && this.editingRowId !== entity.id) {
            this.cancelarEdicaoAtual();
        }

        entity.$$editing = true;
        entity.$$saldoEdicao = entity.saldo;
        this.editingRowId = entity.id;
    }

    salvarEdicaoSaldo(entity: ISaldoInicialRow) {
        if (!this.isSaldoEdicaoValido(entity.$$saldoEdicao)) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Saldo inválido',
                body: 'Informe o saldo no formato HH:MM.',
            });
            return;
        }

        if (entity.bloqueado) {
            this.showSaldoBloqueadoToast();
            return;
        }

        this.busy = true;
        this.ApuracoesPontoService.importarSaldoInicialJson(this.$stateParams['apuracao'], [
            this.buildImportacaoJsonItem(entity, Number(entity.$$saldoEdicao)),
        ]).then((data) => {
            const result = data && data[0];
            const novoSaldo = typeof result?.saldo === 'number'
                ? result.saldo
                : Number(entity.$$saldoEdicao);

            if (!result?.importado) {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Não foi possível atualizar o saldo',
                    body: result?.mensagem || '',
                });
                return;
            }

            entity.saldo = novoSaldo;
            entity.$$editing = false;
            entity.$$saldoEdicao = novoSaldo;
            this.editingRowId = null;

            this.NewToaster.pop({
                type: 'success',
                title: 'Saldo atualizado com sucesso!'
            });
        }).catch((error) => {
            this.showErrorToast(
                'Não foi possível atualizar o saldo',
                this.getErrorMessage(error)
            );
        }).finally(() => {
            this.busy = false;
        });
    }

    cancelarEdicao(entity: ISaldoInicialRow) {
        entity.$$editing = false;
        entity.$$saldoEdicao = entity.saldo;

        if (this.editingRowId === entity.id) {
            this.editingRowId = null;
        }
    }

    abrirModalImportar() {
        const modal = this.SaldoInicialImportarModalService.open({
            file: {} as FileList,
        }, this.allEntities);

        modal.result.then((payload: ISaldoInicialImportacaoArquivo) => {
            this.processarImportacao(payload);
        }).catch(() => { /**/ });
    }

    showSaldoBloqueadoToast() {
        this.NewToaster.pop({
            type: 'warning',
            title: 'Saldo bloqueado',
            body: 'A edição do saldo está bloqueada porque existem pagamentos e/ou compensações.',
        });
    }

    async processarImportacao(filePayload: ISaldoInicialImportacaoArquivo) {
        if (!filePayload.file || !filePayload.file[0]) {
            return;
        }

        const arquivo = filePayload.file[0];
        const fileextension = this.getFileExtension(arquivo.name) as 'csv' | 'xlsx';

        this.busy = true;

        try {
            const arquivoBase64 = await this.fileToBase64(arquivo);
            const response = await this.ApuracoesPontoService.importarSaldoInicialArquivo(
                this.$stateParams['apuracao'],
                fileextension,
                arquivoBase64
            );

            this.handleArquivoImportacaoResponse(response, fileextension);
            await this.loadEntities(true);
        } catch (error) {
            this.showErrorToast(
                'Não foi possível importar a planilha',
                this.getErrorMessage(error)
            );
        } finally {
            this.busy = false;
        }
    }

    private cancelarEdicaoAtual() {
        if (!this.editingRowId) {
            return;
        }

        const entity = this.allEntities.find((item) => item.id === this.editingRowId);
        if (entity) {
            this.cancelarEdicao(entity);
        }
    }

    private formatMinutesToHourString(minutes: number) {
        const sinal = minutes < 0 ? '-' : '';
        const minutosAbsolutos = Math.abs(minutes);
        const horas = Math.floor(minutosAbsolutos / 60).toString().padStart(2, '0');
        const minutosRestantes = (minutosAbsolutos % 60).toString().padStart(2, '0');

        return `${sinal}${horas}:${minutosRestantes}`;
    }

    private getSaldoClass(minutes: number) {
        if (minutes > 0) {
            return 'text-success text-bold';
        }

        if (minutes < 0) {
            return 'text-danger text-bold';
        }

        return 'text-bold';
    }

    private isSaldoEdicaoValido(valor: string | number | undefined) {
        return typeof valor === 'number' && Number.isInteger(valor);
    }

    private applyFilters() {
        const busca = this.normalizeText(this.filters.busca);
        const buscaCpf = (this.filters.busca || '').replace(/\D/g, '');

        if (!busca) {
            this.entities = this.allEntities.slice();
            return;
        }

        this.entities = this.allEntities.filter((entity) =>
            !!entity.$$searchNome?.includes(busca) || (!!buscaCpf && !!entity.$$searchCpf?.includes(buscaCpf))
        );
    }

    private syncBlockedEntitiesState() {
        this.hasBlockedEntities = this.allEntities.some((entity) => entity.bloqueado);
    }

    private mapEntityFromApi(entity: ISaldoInicialTrabalhadorApiResponse): ISaldoInicialRow {
        const cpf = (entity.cpf || '').replace(/\D/g, '');

        return {
            id: entity.trabalhador,
            trabalhador: entity.trabalhador,
            lotacao: entity.lotacao.lotacao,
            codigo: entity.codigo,
            cpf,
            nome: entity.nome,
            saldo: entity.saldo,
            bloqueado: entity.bloqueado,
            $$searchNome: this.normalizeText(entity.nome),
            $$searchCpf: cpf,
            $$editing: false,
            $$saldoEdicao: entity.saldo,
        };
    }

    private loadApuracaoHeader() {
        this.ApuracoesPontoService.get(this.$stateParams['apuracao'])
            .then((apuracao) => {
                this.apuracao = apuracao;
                this.apuracaoResumo = this.buildApuracaoResumo(apuracao);
            })
            .catch(() => {
                this.apuracao = null;
                this.apuracaoResumo = '';
            });
    }

    private buildApuracaoResumo(apuracao: IApuracaoPontoGetResponse) {
        const inicio = moment(apuracao.inicioapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');
        const termino = moment(apuracao.terminoapuracao, 'YYYY-MM-DD').format('DD/MM/YYYY');

        return `Apuração ${inicio} a ${termino}${this.getReferenciaApuracao(apuracao)}`;
    }

    private getReferenciaApuracao(apuracao: IApuracaoPontoGetResponse) {
        if (apuracao.trabalhador?.trabalhador) {
            return ` - Trabalhador: ${apuracao.trabalhador.nome}`;
        }

        if (apuracao.lotacao?.lotacao) {
            return ` - Lotação: ${apuracao.lotacao.nome}`;
        }

        if (apuracao.estabelecimento?.estabelecimento) {
            return ` - Estabelecimento: ${apuracao.estabelecimento.nomefantasia}`;
        }

        if (apuracao.empresa?.empresa) {
            return ` - Empresa: ${apuracao.empresa.razaosocial}`;
        }

        return '';
    }

    private buildImportacaoJsonItem(entity: ISaldoInicialRow, saldo: number): ISaldoInicialImportacaoJsonItemRequest {
        return {
            trabalhador: entity.trabalhador,
            lotacao: entity.lotacao,
            saldo,
        };
    }

    private normalizeText(value?: string | null) {
        return (value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toLowerCase();
    }

    private getFileExtension(fileName: string) {
        const match = fileName.toLowerCase().match(/\.([a-z0-9]+)$/);
        return match?.[1];
    }

    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                const result = typeof reader.result === 'string' ? reader.result : '';
                const base64 = result.split(',')[1];

                if (!base64) {
                    reject(new Error('Não foi possível converter o arquivo para base64.'));
                    return;
                }

                resolve(base64);
            };

            reader.onerror = () => reject(new Error('Não foi possível ler o arquivo selecionado.'));
            reader.readAsDataURL(file);
        });
    }

    private handleArquivoImportacaoResponse(
        response: ISaldoInicialImportacaoArquivoResponse,
        fileextension: 'csv' | 'xlsx'
    ) {
        if (response?.arquivo) {
            this.downloadArquivoRetorno(
                response.arquivo,
                fileextension,
                `retorno-importacao-saldo-inicial-${this.$stateParams['apuracao']}.${fileextension}`
            );
        }

        this.NewToaster.pop({
            type: 'success',
            title: 'Importação concluída!',
            body: response?.arquivo
                ? 'O arquivo de retorno da importação foi baixado para conferência.'
                : 'A importação foi concluída com sucesso.',
        });
    }

    private downloadArquivoRetorno(base64: string, fileextension: 'csv' | 'xlsx', fileName: string) {
        const mimeType = fileextension === 'csv'
            ? 'text/csv;charset=utf-8;'
            : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
    }

    private showErrorToast(title: string, body?: string) {
        this.NewToaster.pop({
            type: 'error',
            title,
            body: body || '',
        });
    }

    private getErrorMessage(error: any) {
        return error?.data?.message || error?.data?.mensagem || error?.data?.erro || undefined;
    }
}
